export default __webpack_public_path__ + "static/media/apple_playstore.a8da37c2.jpg";